module.exports = __webpack_public_path__ + "img/9.7b0b5f21.jpg";